/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GearPrior
 */
export interface GearPrior {
    /**
     * 
     */
    kind: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    lengthMm: number;
    /**
     * 
     */
    note?: string | null;
}

/**
 * Check if a given object implements the GearPrior interface.
 */
export function instanceOfGearPrior(value: object): value is GearPrior {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('lengthMm' in (value as Record<string, any>)) && !('length_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMm'] === undefined && (value as Record<string, any>)['length_mm'] === undefined)) return false;
    return true;
}

export function GearPriorFromJSON(json: any): GearPrior {
    return GearPriorFromJSONTyped(json, false);
}

export function GearPriorFromJSONTyped(json: any, ignoreDiscriminator: boolean): GearPrior {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'name': json['name'],
        'lengthMm': json['length_mm'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
    };
}

export function GearPriorToJSON(json: any): GearPrior {
    return GearPriorToJSONTyped(json, false);
}

export function GearPriorToJSONTyped(value?: GearPrior | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'name': value['name'],
        'length_mm': value['lengthMm'],
        'note': value['note'],
    };
}

